import { initializeApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseEnabled = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId
);

let db: Firestore | null = null;
let auth: Auth | null = null;

console.log('[Firebase] Config check:', {
  apiKey: firebaseConfig.apiKey ? '✓ set' : '✗ missing',
  projectId: firebaseConfig.projectId ? `✓ ${firebaseConfig.projectId}` : '✗ missing',
  authDomain: firebaseConfig.authDomain ? '✓ set' : '✗ missing',
  enabled: firebaseEnabled,
});

if (firebaseEnabled) {
  try {
    const app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
    console.log('[Firebase] ✓ Initialized successfully — Firestore + Auth');
  } catch (error) {
    console.error('[Firebase] ✗ Init failed, falling back to localStorage:', error);
  }
} else {
  console.log('[Firebase] ✗ Not configured — using localStorage');
}

export { db, auth };
